<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
import allEvents from '../../../components/events/all-events'

export default {
  name: 'AllEvents',
  components: {
    allEvents
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/events/all-events.view.vue